interface EmptyInboxProps {
  hasFilters?: boolean;
  onClearFilters?: () => void;
}

export function EmptyInbox({ hasFilters, onClearFilters }: EmptyInboxProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-16 h-16 mb-4 bg-gray-100 rounded-full flex items-center justify-center">
        <svg
          className="w-8 h-8 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
          />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">No conversations found</h3>
      <p className="text-gray-500 text-sm text-center max-w-sm">
        {hasFilters
          ? 'Try adjusting your filters to see more conversations.'
          : 'New conversations will appear here when customers reach out.'}
      </p>
      {hasFilters && onClearFilters && (
        <button
          onClick={onClearFilters}
          className="mt-4 text-sm text-blue-600 hover:text-blue-700 font-medium"
        >
          Clear filters
        </button>
      )}
    </div>
  );
}
